module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAABQElEQVQoU3WRsSuFYRjFz3nfK6UMEoM/QBlMt75rtUqkrAwURclgEb77XrmDwaQwEcpESnLLokw+DDabzSSSTd/7vUf3Fl1Xnu3p+T3nnDpEw/Qtf/bI5saZ+YObtebH+jPrlz7nhyQeQngF0U5q7Mblzr6ZHziK0yWSDoariUy5wLCEoFiSu11tKlcfmHdqyYVsV8AggWuBV8GYk3vHpyj2IzTcR9CFN3aCBeePBQ4CWKC0KeCd4FFSsrNVtUKsfplQIXTO/Ip6rcl2IDzTcFRSSnI7cXa+CkfFbJ1Q5IOdq2WOir5C8AHGXIY0azOW3SJmGPAm6J5ER1LKDf+Ck5JdrFkX/R7AAUCdICoQ0n/hKM6mCa2AfBVxR6leOdsgMAnopbEkgJ0AtqqutRj5KTWZrmyEAa1/YXzcGnsKR/8F+VKRA9QmtgMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/blueHomeIcon.png
// module id = zVBY
// module chunks = 3